import { keyframes } from "@mui/material";

/**
 * MYM Specs View palette — matched to /MindYourMusic.png
 * magenta → coral/orange → golden yellow
 */
export const SPECS = {
  magenta: "#ff2d8a",
  magentaDeep: "#e91e63",
  orange: "#ff6b2c",
  orangeHot: "#ff4500",
  gold: "#ffc107",
  goldSoft: "#ffb300",
  ink: "#000000",
  inkSoft: "#0a0a0a",
  panel: "rgba(10, 10, 10, 0.78)",
  panelBorder: "rgba(255, 255, 255, 0.12)",
  muted: "rgba(255, 255, 255, 0.72)",
  fontDisplay: '"Syne", "Avenir Next", system-ui, sans-serif',
  fontBody: '"DM Sans", "Helvetica Neue", system-ui, sans-serif',
  /** Brand text fill — same direction as the logo */
  textGradient:
    "linear-gradient(115deg, #ff2d8a 0%, #ff6b2c 48%, #ffc107 100%)",
  textGlow:
    "0 0 24px rgba(255,45,138,0.35), 0 0 48px rgba(255,107,44,0.22)",
};

export const specsPulse = keyframes`
  0%, 100% { opacity: 0.45; transform: scale(1); }
  50% { opacity: 0.9; transform: scale(1.06); }
`;

export const specsGlow = keyframes`
  0%, 100% { filter: drop-shadow(0 0 10px rgba(255,45,138,0.4)); }
  50% { filter: drop-shadow(0 0 26px rgba(255,193,7,0.55)); }
`;

export const specsFloat = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

export const specsFadeSlide = keyframes`
  from { opacity: 0; transform: translateY(28px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const specsRaySpin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const specsParticleDrift = keyframes`
  0% { transform: translateY(0) translateX(0); opacity: 0; }
  15% { opacity: 0.7; }
  85% { opacity: 0.5; }
  100% { transform: translateY(-110vh) translateX(18px); opacity: 0; }
`;

export const specsShimmer = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 200% 50%; }
`;

export const specsPageSx = {
  position: "fixed",
  inset: 0,
  width: "100vw",
  height: "100vh",
  "@supports (height: 100dvh)": {
    height: "100dvh",
  },
  overflow: "hidden",
  fontFamily: SPECS.fontBody,
  color: "#fff",
  background:
    "radial-gradient(ellipse 80% 55% at 18% 20%, rgba(255,45,138,0.2) 0%, transparent 55%)," +
    "radial-gradient(ellipse 70% 50% at 88% 75%, rgba(255,193,7,0.14) 0%, transparent 50%)," +
    "radial-gradient(ellipse 50% 40% at 55% 100%, rgba(255,107,44,0.12) 0%, transparent 45%)," +
    "linear-gradient(165deg, #000000 0%, #0a0508 42%, #000000 100%)",
  display: "flex",
  flexDirection: "column",
  userSelect: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    opacity: 0.22,
    backgroundImage:
      "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)," +
      "linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
    backgroundSize: "64px 64px",
    maskImage:
      "radial-gradient(ellipse 75% 65% at 45% 40%, #000 15%, transparent 78%)",
  },
};

export const SLIDE_INTERVAL_MS = 11000;

export const JOIN_PATH = "/mindyourmusic";

export const FEATURES = [
  { emoji: "🎮", label: "PLAY", accent: SPECS.magenta },
  { emoji: "🎵", label: "REQUEST", accent: SPECS.orange },
  { emoji: "🏆", label: "COMPETE", accent: SPECS.gold },
  { emoji: "🎁", label: "WIN", accent: SPECS.magentaDeep },
];

export const HERO_SLIDES = [
  {
    id: "night",
    kind: "tagline",
    lines: ["YOUR NIGHT.", "YOUR MUSIC.", "YOUR GAME."],
    visual: "/MindYourMusic.png",
  },
  {
    id: "play",
    kind: "tagline",
    lines: ["PLAY.", "COMPETE.", "WIN."],
    visual: "/assets/higherorlowerLogo.png",
  },
  {
    id: "games",
    kind: "games",
    title: "DISCOVER MYM GAMES",
    games: [
      { name: "Higher or Lower", image: "/assets/higherorlowerLogo.png" },
      { name: "Beerillionaire", image: "/beer2.png" },
      { name: "Quiz", image: "/FlashQuiz2.png" },
      { name: "Spin the Wheel", image: "/assets/spinthewheel.png" },
    ],
  },
  {
    id: "part",
    kind: "tagline",
    lines: ["DON'T JUST WATCH", "THE NIGHT.", "BE PART OF IT."],
    visual: "/assets/spinthewheel.png",
  },
];
